import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/lokasi',
    name: 'lokasi',
    component: () => lazyLoadView(import('@views/admin/lokasi/List.vue')),
    meta: {
      title: 'Lokasi',
    },
  },
  {
    path: '/:operator/:id(\\d+)/lokasi/:lokasi_id(\\d+)/:tab(\\d+)?',
    name: 'lokasi-detil',
    component: () => lazyLoadView(import('@views/admin/lokasi/Detail.vue')),
    meta: {
      title: 'Profil Lokasi',
    },
  },
];
